import { findActivityBySlug, hasProperty } from "@/lib/util";

function createCategoryOption(
  slug: Travelguide.Activity,
  defaultLabel: string
): Catalog.Category.Option {
  const { categories } = findActivityBySlug(slug);
  if (!categories) {
    throw new Error(`No categories found for slug '${slug}'.`);
  }

  const sortedCategories = [...categories];
  sortedCategories.sort((a, b) =>
    a.title < b.title ? -1 : b.title < a.title ? 1 : 0
  );

  return {
    name: "category",
    labels: [defaultLabel].concat(sortedCategories.map(({ title }) => title)),
    values: ([null] as Array<Catalog.Category.Value>).concat(
      sortedCategories
        .filter(hasProperty<"ids", Travelguide.ID>("ids"))
        .map(({ ids }) => ids)
    ),
  };
}

export function getOptionsBySlug(
  slug: Travelguide.Activity
): Array<Catalog.Options> | undefined {
  const defaultLabel = {
    touren: "Alle Tourenarten",
    "familie-kinder": "Alle Aktivitäten",
    "sport-gesundheit": "Alle Angebote",
    sehenswert: "Alles Sehenswerte",
    unterkunft: "Alle Unterkünfte",
    naturatlas: null,
  }[slug];

  if (!defaultLabel) {
    return;
  }

  if (slug === "touren") {
    return [
      createCategoryOption(slug, defaultLabel),
      {
        name: "distance",
        labels: ["Alle Tourenlängen", "< 4 km", "4 - 10 km", "> 10 km"],
        values: [null, [0, 4000], [4000, 10000], [10000]],
      },
      {
        name: "difficulty",
        labels: ["Alle Schwierigkeitsgrade", "leicht", "mittel", "schwer"],
        values: [null, 1, 2, 3],
      },
    ];
  }

  return [createCategoryOption(slug, defaultLabel)];
}
